<template>
  <div class="home" >
   <div class="container p-l-r-0 container-shadow">
    <div class="row">
      <UserProfile></UserProfile>
    </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
            <LeftNav :type="'OverView'"/>
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
           <div class="container" style="margin-top:20px;font-size:13px !important">
               <div v-for="data in list" :key="data.id"   class="row data-list" >
                  <div class="col-sm-6 left" >
                      <div class="form-check">
                          <!-- <input type="checkbox" class="form-check-input" id="service-check"> -->
                          <label class="form-check-label" for="service-check">
                              <span class="service_status">
                              Status :  <span>{{ data.status=='Yes' ? 'Active' :'Not Active' }}</span>
                              </span>
                          </label>
                      </div>
                      <div class="services-list">  
                          <p class="date"><span>Date:</span>
                          {{ formatDate(data.date, 'D-MMM-YYYY ') }}
                          </p>
                          <p>
                              <span>Service:</span> {{data.subscription_type}}{{data.company_name=='' ? '' :' - '+data.company_name}}
                          </p>  
                      </div>
                      
                      <div>
                          
                          <a  v-if="data.status=='Yes'" href="javascript://" @click="Invoice(data.id )" class="gobtn">Invoice</a>
                           <a href="javascript://" @click="ActivityMenu(data.unique_id,'chat',data.url_type)" class="gobtn">More</a>
                           <a v-if="data.url_type=='BS'" href="javascript://"  @click="ActivityMenu(data.unique_id,'company_info',data.url_type)" class="gobtn entity_form_btn" style="position: relative;">Information sheet <span class="span_tooltip"><span class="arrow-top"></span>Please fill this information sheet to proceed further</span></a>
                      </div>
                  </div>
                  <div class="col-sm-6 right">
                      <ul>
                          <li>
                            <a href="javascript://" @click="ActivityMenu(data.unique_id,'chat',data.url_type)">
                              <span class="chat">Chat : {{data.chat_count}}</span>
                            </a>
                          </li>
                          <li>
                            <a href="javascript://" @click="ActivityMenu(data.unique_id,'files',data.url_type)">
                              <span class="files">Files: {{data.files_count}} </span>
                            </a>
                          </li>
                          <li>
                            <a href="javascript://" @click="ActivityMenu(data.unique_id,'summary',data.url_type)">
                              <span class="summanry_milestone">Summary:  {{data.summary_count}}</span>
                            </a>
                          </li>
                      </ul>   
                  </div>  
              </div>  
            </div>  
         </div>
    </div>
    <CommonChat/>
</div>
  </div>
</template>

<script>
// @ is an alias to /src
import LeftNav from "../layouts/leftNav.vue"
import UserProfile from "../layouts/profile-header.vue"
import { mapGetters } from 'vuex'
import Overview from "../../services/overview";
import Invoice from '../../services/invoice';
import CommonChat from "../../components/common_chat.vue"
import moment from 'moment'
export default {
  name: 'bs-index',
  data(){
    return {
      list:{},
      file_path:process.env.VUE_APP_URL,
    }
  },
  components: {
    LeftNav,
    UserProfile,
    CommonChat
  },
  computed:{
    ...mapGetters('user', {
      userList: 'list',
    })
  },
  created(){
    //  this.$store.dispatch('user/fetchUsers')
  },
  methods:{
    formatDate(date,format){
             return moment(date).format(format);
        },
         ActivityMenu(id,activity_type,sub_type){
            var   type_url=sub_type=='BS' ? 'business_setup' : 'accounting_service';
            this.$router.push({name:'workspace',params:{type:type_url,activity_type:activity_type,id:id }})
        },
          Invoice(subscriptionId){
            Invoice.get({'subscription_id':subscriptionId})
                    .then(res=>{
                        var response = res.data;
                         const url = this.file_path + response.path + "/" + response.file;
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = '_blank';
                            link.type = 'application/octet-stream';
                            link.download=response.file
                            // link.setAttribute("download", response.file); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // link.remove();
                    })
                    .catch(err=>{console.log(err)});
        }
  },
  mounted(){
    Overview.get({from:'overview'})
            .then(response =>{
              this.list=response.data.list;
            })
  this.$store.dispatch('profile/fetchProfile')
      .then((data) => {
        if(data.data.profile.is_tour == 0){
          this.$router.push({name:'Tour'})
        }
      })
                  
  }
};
</script>
